import React from 'react';
import { 
  Card, 
  CardContent, 
  Typography 
} from '@mui/material';
import MemoryIcon from '@mui/icons-material/Memory';

interface TutorMemoryCardProps {
  tutorProgress: {
    statement?: string;
    updatedAt?: string;
  } | null;
}

const TutorMemoryCard: React.FC<TutorMemoryCardProps> = ({ tutorProgress }) => {
  return (
    <Card sx={{ borderRadius: 3, border: '1px solid', borderColor: 'divider' }}>
      <CardContent>
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 1, mb: 1.5, color: 'primary.main' }}>
          <MemoryIcon /> Sven's Student Memory
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic', lineHeight: 1.6 }}>
          {tutorProgress?.statement || "Sven is building a profile of your Swedish vocabulary and grammar knowledge as you complete lessons."}
        </Typography>
        {tutorProgress?.updatedAt && (
          <Typography variant="caption" color="text.disabled" sx={{ display: 'block', mt: 1 }}>
            Last updated: {new Date(parseInt(tutorProgress.updatedAt)).toLocaleString()}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default TutorMemoryCard;
